import { Navigate, Outlet, Route } from "react-router";

import { useAppSelector } from "../../services/hooks.ts";
import SpinnerContainer from "../../components/Spinner/SpinnerContainer.tsx";

function ProtectedRouteLoggedIn() {
    const loaded = useAppSelector((state) => state.user.loaded);
    const loggedIn = useAppSelector((state) => state.user.logged);

    if (!loaded) return <SpinnerContainer enabled={true} ><div style={{ height: "50vh" }}></div></SpinnerContainer>;

    if (loggedIn) return <Outlet />;

    return <Navigate to={'/404'} replace />
}


const DashboardRoute = (
    <Route id="dashboard-root" element={<ProtectedRouteLoggedIn />} />
)

export default DashboardRoute;